import e from "./DsButton.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                         */
import t from "../_virtual/_plugin-vue_export-helper.js";
// src/components/DsButton.vue
var n = /*#__PURE__*/ t(e, [["__scopeId", "data-v-ef3f7288"]]);
export { n as default };

//# sourceMappingURL=DsButton.js.map